import React from "react";
import {render} from "react-dom";
import App from "./components/App";
import "./index.css";
import "./css/summit-layouts.css";

const container = document.getElementById("root");

render(<App />, container);
